import * as Yup from 'yup';
import { Formik } from 'formik';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  FiCalendar,
  FiCreditCard,
  FiFile,
  FiMapPin,
  FiShoppingCart,
  FiUser,
} from 'react-icons/fi';

import { parseCookies } from 'nookies';
import { Box } from '@mui/material';
import { format } from 'date-fns';
import { Headline } from '../../components/LegacyV4Components';
import v4CompanyLogo from '../../assets/logos/v4-company-logo.svg';
import { AboutYou } from '../../components/AtomicDesign/templates/AboutYou';
import { AddressPayment } from '../../components/AtomicDesign/templates/AddressPayment';
import { convertNumberToBRL } from '../../utils/convertNumberToBRL';
import { IResponsePlans } from '../../services/requests/Finance/createPayment';

import * as S from './styles';
import { ModalCookies } from '../../components/AtomicDesign/molecules/ModalCookies';
import { ModalAcceptedCookies } from '../../components/AtomicDesign/molecules/ModalAcceptedCookies';
import { ValidateCPFOrCNPJ } from '../../utils/validateCPFOrCNPJ';
import { UnHappyPath } from '../../components/AtomicDesign/atoms/UnhappyPath';
import { useQueryGetPlanList } from '../../services/requests/Finance/getPlanList';
import { PlanSubscription } from '../../components/AtomicDesign/templates/PlanSubscription';
import { ResumePlans } from '../../components/AtomicDesign/templates/ResumePlans';
import { FinishPlanPayment } from '../../components/AtomicDesign/templates/FinishPlanPayment';

export interface FormikPlansOptions {
  // recipientId: string;
  recipientId?: string;
  ticketUnitId?: string;
  quantity?: number;
  planId?: string;
  paymentMethod?: string;
  telephone?: string;
  finalValue?: number;
  couponApplied?: string;
  discount?: number;
  cpf?: string;
  phone?: string;
  name: string;
  email: string;
  planIdentifier?: string;
  address: {
    district: string;
    number: null;
    street: string;
    zipCode?: string;
    zip_code?: string;
    complement: string;
  };
  paymentCardToken: {
    first_name?: string;
    last_name?: string;
    number?: string;
    month?: string;
    year?: string;
    verification_value?: string;
  };
  cardName?: string;
  cardNumber?: string;
  monthAvailable?: string;
  yearAvailable?: string;
  cvv?: string;
  cpf_cnpj?: string;
  parcelas?: string;
}

export function PlanOptions() {
  const [isLoading, setIsLoading] = useState(false);
  const [indexTab, setIndexTab] = useState<number>(1);
  const [paymentIsCreate, setPaymentIsCreate] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(true);
  const [isCookiesAccepted, setIsCookiesAccepted] = useState<string>();
  const [responsePayment, setResponsePayment] = useState({} as IResponsePlans);
  const { id } = useParams<{ id: string }>();

  const { data: product } = useQueryGetPlanList(id);

  const configBankSchema = Yup.object().shape({
    name: Yup.string().required('O campo é obrigatório!'),
    email: Yup.string()
      .email('E-mail inválido')
      .required('Formato de e-mail inválido.'),
    telephone: Yup.string()
      .min(11, 'Número inválido')
      .required('Insira seu número'),
    cpf: Yup.string()
      .max(14, 'CPF inválido')
      .required('Insira seu cpf')
      .test((value) => ValidateCPFOrCNPJ(value))
      .nullable(),
    parcelas: Yup.string(),
    cvv: Yup.string(),
    address: Yup.object().shape({
      district: Yup.string().required('O campo é obrigatório!'),
      number: Yup.number().required('O campo é obrigatório'),
      street: Yup.string().required('O campo é obrigatório!'),
      zipCode: Yup.string().required('O campo é obrigatório!'),
      complement: Yup.string().required('O campo é obrigatório!'),
    }),
    paymentCardToken: Yup.object().shape({
      first_name: Yup.string().required('O campo é obrigatório!'),
      last_name: Yup.string().required('O campo é obrigatório!'),
      number: Yup.string().required('O campo é obrigatório!'),
      month: Yup.string().required('O campo é obrigatório!'),
      year: Yup.string().required('O campo é obrigatório!'),
      verification_value: Yup.string().required('O campo é obrigatório!'),
    }),
  });

  useEffect(() => {
    const { 'v4company.cookiesAccepted': cookiesAccepted } = parseCookies();

    if (!cookiesAccepted) {
      setIsOpenModal(true);
      return;
    }
    setIsOpenModal(false);
    setIsCookiesAccepted(cookiesAccepted);
  }, []);

  const customerHexColor = 'var(--success-2)';

  return (
    <>
      <Formik
        initialValues={{
          planId: `${id}`,
          paymentCardToken: {
            first_name: '',
            last_name: '',
            number: '',
            month: '',
            year: '',
            verification_value: '',
          },
          name: '',
          email: '',
          telephone: '',
          cpfCnpj: '',
          address: {
            district: '',
            number: null,
            street: '',
            zipCode: '',
            complement: '',
          },
        }}
        validationSchema={configBankSchema}
        onSubmit={async () => {
          setIndexTab(indexTab + 1);
        }}
      >
        {({ errors, values, handleBlur, setFieldValue, touched }) => (
          <Box>
            {product?.data?.disabled === true ? (
              <S.LinkDisabled>
                <Box className="ContainerDisabled">
                  <UnHappyPath
                    assetIndex={1}
                    title="Este link de pagamento está desabilitado ou não existe."
                  />
                </Box>
              </S.LinkDisabled>
            ) : (
              <>
                <S.Container>
                  <S.Navbar>
                    {indexTab !== 5 ? (
                      <>
                        <S.ContainerTabs>
                          <section
                            style={{
                              border: `${
                                indexTab === 1 &&
                                `1px solid ${customerHexColor}`
                              }`,
                              background: `${
                                indexTab === 1 ? `#fff` : `${customerHexColor}`
                              }`,
                            }}
                            aria-hidden
                            className={`${
                              (indexTab === 1 && `selected`) ||
                              (indexTab !== 1 && 'NotSelected')
                            }`}
                            key={1}
                            onClick={() => {
                              if (
                                values.name &&
                                !errors.name &&
                                !errors.email &&
                                values.email &&
                                values.cpfCnpj &&
                                !errors.cpfCnpj &&
                                values.telephone
                                // !errors.tel
                              ) {
                                indexTab === 1 && setIndexTab(1);
                                indexTab === 2 && setIndexTab(indexTab - 1);
                              }
                            }}
                          >
                            <FiUser
                              color={
                                indexTab === 1
                                  ? `${customerHexColor}`
                                  : '#333333'
                              }
                            />
                            <span>Sobre você</span>
                          </section>
                        </S.ContainerTabs>
                        <S.ContainerTabs>
                          <section
                            style={{
                              border: `${
                                indexTab === 2
                                  ? `1px solid ${customerHexColor}`
                                  : '1px solid #dadae7'
                              }`,
                              background: `${
                                (indexTab === 2 && `#fff`) ||
                                (indexTab > 2 && `${customerHexColor}`)
                              }`,
                            }}
                            aria-hidden
                            className={`${
                              (indexTab === 2 && `selected`) ||
                              (indexTab > 2 && 'NotSelected')
                            }`}
                            key={2}
                            onClick={() => {
                              if (
                                values.name &&
                                !errors.name &&
                                !errors.email &&
                                values.email &&
                                values.cpfCnpj &&
                                !errors.cpfCnpj &&
                                values.telephone
                                // !errors.tel
                              ) {
                                indexTab === 1 && setIndexTab(2);
                                indexTab === 3 && setIndexTab(indexTab - 1);
                              }
                            }}
                          >
                            <FiMapPin
                              color={
                                indexTab === 2 ? `${customerHexColor}` : ''
                              }
                            />
                            <span>Endereço de cobrança</span>
                          </section>
                        </S.ContainerTabs>
                        <S.ContainerTabs>
                          <section
                            style={{
                              border: `${
                                indexTab === 3
                                  ? `1px solid ${customerHexColor}`
                                  : '1px solid #dadae7'
                              }`,
                              background: `${
                                (indexTab === 3 && `#fff`) ||
                                (indexTab > 3 && `${customerHexColor}`)
                              }`,
                            }}
                            aria-hidden
                            className={`${
                              (indexTab === 3 && `selected`) ||
                              (indexTab > 3 && 'NotSelected')
                            }`}
                            key={3}
                            onClick={() => {
                              if (
                                !errors.address?.zipCode &&
                                !errors.address?.complement &&
                                !errors.address?.district &&
                                !errors.address?.number &&
                                !errors.address?.street
                              ) {
                                indexTab === 2 && setIndexTab(3);
                                indexTab === 4 && setIndexTab(indexTab - 1);
                              }
                            }}
                          >
                            <FiCreditCard
                              color={
                                indexTab === 3 ? `${customerHexColor}` : ''
                              }
                            />
                            <span>Pagamento</span>
                          </section>
                        </S.ContainerTabs>
                        <S.ContainerTabs>
                          <section
                            style={{
                              border: `${
                                indexTab === 4
                                  ? `1px solid ${customerHexColor}`
                                  : '1px solid #dadae7'
                              }`,
                              background: `${
                                indexTab > 4 && `${customerHexColor}`
                              }`,
                            }}
                            aria-hidden
                            className={`${
                              (indexTab === 4 && `selected`) ||
                              (indexTab > 4 && 'NotSelected')
                            }`}
                            key={4}
                            onClick={() => {
                              indexTab === 3 && setIndexTab(4);
                            }}
                          >
                            <FiFile
                              color={
                                indexTab === 4 ? `${customerHexColor}` : ''
                              }
                            />
                            <span>Resumo</span>
                          </section>
                        </S.ContainerTabs>
                      </>
                    ) : null}
                  </S.Navbar>

                  <S.Body theme={indexTab === 5 ? 'center' : 'space-between'}>
                    {indexTab !== 5 ? (
                      <S.RequestsMobile
                        color={indexTab === 4 ? 'none' : 'block'}
                        style={{ border: `1px solid ${customerHexColor}` }}
                      >
                        <div className="your-request">
                          <FiShoppingCart />
                          <Headline variant="h5">Seu pedido</Headline>
                        </div>
                        <section>
                          <div className="your-product">
                            <p>{product?.data?.name || ''}</p>
                            <p>
                              {product?.data
                                ? convertNumberToBRL(
                                    product?.data?.valueCents / 100,
                                  )
                                : ''}
                            </p>
                          </div>
                          <p style={{ display: 'flex', alignItems: 'center' }}>
                            <FiCalendar /> Você pagará todo dia{' '}
                            {format(new Date(), 'dd')}
                          </p>
                        </section>
                      </S.RequestsMobile>
                    ) : null}

                    {indexTab === 1 && (
                      <AboutYou
                        touched={touched}
                        setFieldValue={setFieldValue}
                        indexTab={indexTab}
                        setIndexTab={setIndexTab}
                        values={values}
                        errors={errors}
                        handleBlur={handleBlur}
                      />
                    )}

                    {indexTab === 2 && (
                      <AddressPayment
                        touched={touched}
                        indexTab={indexTab}
                        setIndexTab={setIndexTab}
                        setFieldValue={setFieldValue}
                        values={values}
                        errors={errors}
                        handleBlur={handleBlur}
                      />
                    )}

                    {indexTab === 3 && (
                      <PlanSubscription
                        touched={touched}
                        indexTab={indexTab}
                        setIndexTab={setIndexTab}
                        setFieldValue={setFieldValue}
                        values={values}
                        errors={errors}
                        handleBlur={handleBlur}
                      />
                    )}
                    {indexTab === 4 && (
                      <ResumePlans
                        data={product?.data}
                        indexTab={indexTab}
                        setIndexTab={setIndexTab}
                        values={values}
                        setPaymentIsCreate={setPaymentIsCreate}
                        setResponsePayment={setResponsePayment}
                        setIsLoading={setIsLoading}
                        isLoading={isLoading}
                        customerHexColor={customerHexColor}
                      />
                    )}
                    {indexTab === 5 && paymentIsCreate ? (
                      <FinishPlanPayment
                        responsePayment={responsePayment}
                        values={values}
                        data={product?.data}
                      />
                    ) : null}

                    {indexTab !== 5 ? (
                      <S.RequestsDesktop
                        color={indexTab === 4 ? 'none' : 'block'}
                        style={{ border: `1px solid ${customerHexColor}` }}
                      >
                        <div className="your-request">
                          <FiShoppingCart />
                          <Headline variant="h5">Seu pedido</Headline>
                        </div>
                        <section>
                          <div className="your-product">
                            <p>{product?.data?.name || ''}</p>
                            <p>
                              {product?.data
                                ? convertNumberToBRL(
                                    product?.data?.valueCents / 100,
                                  )
                                : ''}
                            </p>
                          </div>
                          <p style={{ display: 'flex', alignItems: 'center' }}>
                            <FiCalendar /> Você pagará todo dia{' '}
                            {format(new Date(), 'dd')}
                          </p>
                        </section>
                      </S.RequestsDesktop>
                    ) : null}
                  </S.Body>

                  <S.Footer>
                    <p>
                      Desenvolvido por: <img src={v4CompanyLogo} alt="" />
                    </p>
                    <span>2022 © Todos os direitos reservados. V4 Company</span>
                  </S.Footer>
                </S.Container>
              </>
            )}
          </Box>
        )}
      </Formik>
      {!isOpenModal ? (
        <S.Cookie>
          <ModalCookies />
          {/* <BiCookie size={33} /> */}
        </S.Cookie>
      ) : null}
      {!isCookiesAccepted ? (
        <ModalAcceptedCookies
          show={isOpenModal}
          onClose={() => setIsOpenModal(false)}
        />
      ) : null}
    </>
  );
}
